import * as Yup from "yup";

export const DeductionSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().required("Campo requerido"),
  amount: Yup.number()
    .required("Campo requerido")
    .positive("No debe ser menor a 0"),
  frequency: Yup.string()
    .required("Campo requerido")
    .notOneOf(["-99"], "Campo requerido"),
  startDate: Yup.string()
    .when("frequency", {
      is: (val) => val !== "4",
      then: (schema) => schema.required("Campo requerido"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test(
      "is-before-endDate",
      "La fecha de inicio no puede ser mayor que la fecha de fin",
      function (value) {
        const { endDate, frequency } = this.parent;
        if (frequency === "4") return true; // Skip validation if frequency is 4
        return !endDate || !value || new Date(value) <= new Date(endDate);
      }
    ),
  endDate: Yup.string()
    .when("frequency", {
      is: (val) => val !== "4",
      then: (schema) => schema.required("Campo requerido"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test(
      "is-after-startDate",
      "La fecha de fin no puede ser menor que la fecha de inicio",
      function (value) {
        const { startDate, frequency } = this.parent;
        if (frequency === "4") return true; // Skip validation if frequency is 4
        return !startDate || !value || new Date(value) >= new Date(startDate);
      }
    ),
  applicationDate: Yup.string().when("frequency", {
    is: "4",
    then: (schema) => schema.required("Campo requerido"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
